import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton, Modal } from "../../../../../../../components/ui";
import useUser from "../../../../../../../hooks/useUser";
import EditOffer from "../../../../../../Offer/pages/List/components/EditOffer";

const Actions = (props = {}) => {
  const { id: offerId, values: offer } = props;
  const { hasPermission } = useUser();
  const modalProps = {
    body: EditOffer,
    closeOnBackdrop: false,
    hideCloseButton: false,
    scale: "lg",
    offer,
  };

  if (!offerId) return null;

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid">
        <Modal {...modalProps}>
          {hasPermission("UPDATE_OFFER") && (
            <IconButton variant="clean" title="Edit Offer">
              <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
            </IconButton>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
